module.exports = __webpack_public_path__ + "static/media/tools.f025b910.png";